import TitleHeader from "../../general/TitleHeader";
import emailjs from "emailjs-com";
import { FaHeadset } from "react-icons/fa6";
import { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Form from "./components/Form";
import ContactImg from "./components/ContactImg";

export default function Contact() {
  const form = useRef();

  // to make every inputs in form empty
  const [value, setValue] = useState({});

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_KEY,
        process.env.REACT_APP_TEMPLATE_KEY,
        form.current,
        process.env.REACT_APP_PUBLICK_KEY
      )
      .then(
        () => {
          toast("SUCCESS!", {
            // custom-progress-bar-success
            progressClassName: "bg-[#07bc0c]",
          });

          // to make every inputs in form empty
          setValue({ inputVal: "" });
        },
        (error) => {
          toast("Try Again", {
            // custom-progress-bar-wrong
            progressClassName: "bg-red",
          });

          console.error("somthing is wrong in email.js", error);
        }
      );
  };

  return (
    <section id="contact" className="bg-dark-forest relative">
      {/* header component */}
      <TitleHeader icon={<FaHeadset />} title={"Get In Touch"} />

      {/* *********************************************************************************************************** */}

      <div className="container bg-white rounded-xl shadow-lg flex items-center justify-evenly py-7 ">
        {/* img cntact */}
        <ContactImg />

        {/* *********************************************************************************************************** */}
        {/* to know user is form sending */}
        <ToastContainer limit={1} />

        {/* form to send email */}
        <Form sendEmail={sendEmail} form={form} value={value} />

        {/* *********************************************************************************************************** */}
      </div>
    </section>
  );
}
